import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-our-networkothers',
  templateUrl: './our-networkothers.component.html',
  styleUrls: ['./our-networkothers.component.css']
})
export class OurNetworkothersComponent implements OnInit {
  activeTab = "followers"
  loading = false
  arrList
  totalItems
  objArr
  pageNo
  pageSize
  communityID
  communityData
  partnerarr
  arr =[1,2,4,5]
  constructor(private authService: AuthservicesService, private route: ActivatedRoute, private router: Router) {

    this.pageSize = 10
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.communityID = params["id"];
    });


    this.userList(1)
  }


  userList(event) {
    this.pageNo = event
    let skip = this.authService.createSkip(event, this.pageSize);
    this.authService.getcommlList(this.communityID, skip, this.pageSize).subscribe((res: any) => {
      let arr = []
      this.loading = true
      this.arrList = res.items
      this.totalItems = res.total
      this.arrList.forEach(element => {
        arr.push(element.user)
      });
      this.objArr = this.createArray(arr)
    },
      error => {
        this.loading = true
        this.objArr = []
        console.log(error)
      })
  }


  getBlockCommunity(id) {
    let swall = this.authService.swal('block')
    swall.then((result) => {
      if (result.value == true) {
        this.authService.blockUser(id).subscribe((res: any) => {
          this.authService.successMessage(res.message, 'success')
          this.userList(1)
        },
          error => {
            this.authService.successMessage(error.error.message, 'error')
          })
      }
    })
  }



  createArray(arr) {
    let obj = []
    arr.forEach((e) => {
      obj.push({
        id: (e._id) ? e._id : '',
        name: (e.name) ? e.name : '',
        photo: (e.photo) ? this.renderImage(e.photo) : '',
        type: 'Unblocked',
        reported: 'No'

      })
    })
    return obj;
  }



  communityDetail() {
    
    this.authService.communitydetails(this.communityID).subscribe((res: any) => {
      this.communityData = res.data
       this.loading = true
       this.objArr = this.createArray(this.communityData.partners)


    },
      error => {
        console.log(error)
      })
  }



  getScrollTo(id: string) {

    this.activeTab = id
    this.loading = false;
   if(this.activeTab  == 'followers'){
    this.userList(1)

   }
   else if(this.activeTab  == 'partner'){
    this.communityDetail()

   }

    const element = this.getElementById(id)
  }

  getElementById(id: string): HTMLElement {
    const element = <HTMLElement>document.querySelector(`#${id}`);
    return element;
  }


  renderImage(data) {
    return this.authService.spilturl(data)
  }
}
